export const ARTICLES = [
  {
    id: "five-division-framework",
    tag: "Company",
    date: "AUG 2026",
    readTime: "4 MIN READ",
    title: "Future Factory Group Launches Five-Division Operating Framework",
    excerpt:
      "The group formalizes its cross-sector architecture, uniting software, manufacturing, energy, agriculture, and real estate under one core engine.",
    image: "/images/network.png",
    featured: true,
    body: [
      "Future Factory Group has formally activated its five-division operating framework, consolidating its technology, advanced manufacturing, clean energy, sustainable agriculture, and intelligent real estate pipelines into a single integrated ecosystem.",
      "The framework establishes a shared software core — proprietary tooling that tracks, optimizes, and powers physical assets across every division — allowing each sector to compound the progress of the others.",
      "Partner onboarding across all five divisions opens this quarter, with initial joint ventures prioritized along the energy and manufacturing corridors.",
    ],
  },
  {
    id: "enterprise-app-pipeline",
    tag: "Technology",
    date: "AUG 2026",
    readTime: "3 MIN READ",
    title: "Tech Division Opens Enterprise App Pipeline for Q3",
    excerpt:
      "Three enterprise software builds enter active development, spanning logistics, field operations, and industrial telemetry.",
    image: "/images/tech.png",
    body: [
      "The Tech & App Architecture division has greenlit three enterprise builds for Q3: a logistics orchestration suite, a field-operations companion app, and an industrial telemetry dashboard designed to feed the group's own manufacturing data loops.",
      "Each build runs on the division's standard pipeline — security-hardened backends, offline-first mobile clients, and deployment automation — the same stack offered to external partners.",
    ],
  },
  {
    id: "manufacturing-hub-assembly",
    tag: "Manufacturing",
    date: "JUL 2026",
    readTime: "3 MIN READ",
    title: "First Advanced Manufacturing Hub Enters Assembly Phase",
    excerpt:
      "Robotic work cells and automated tooling lines are being configured for the division's pilot production facility.",
    image: "/images/manufacturing.png",
    body: [
      "The Advanced Manufacturing division has begun assembly of its pilot production hub, configuring robotic work cells and automated tooling lines for precision component fabrication.",
      "The facility is designed as a software-defined factory: every machine reports into the group's telemetry core, enabling predictive maintenance and rapid retooling between production runs.",
    ],
  },
  {
    id: "microgrid-blueprint-v1",
    tag: "Energy",
    date: "JUL 2026",
    readTime: "3 MIN READ",
    title: "Microgrid Blueprint v1: Clean Energy Systems Go Live",
    excerpt:
      "The energy division publishes its first deployable microgrid reference architecture for industrial and residential sites.",
    image: "/images/energy.png",
    body: [
      "Clean Energy Systems has published Microgrid Blueprint v1 — a modular reference architecture combining solar arrays, battery storage, and intelligent load balancing for industrial and residential deployments.",
      "The blueprint is engineered to power the group's own manufacturing and real estate assets first, creating a live proving ground before partner rollouts.",
    ],
  },
  {
    id: "climate-smart-pilot-farms",
    tag: "Agriculture",
    date: "JUN 2026",
    readTime: "2 MIN READ",
    title: "Climate-Smart Pilot Farms Begin Data Collection",
    excerpt:
      "Sensor arrays and drone imaging are now streaming crop telemetry into the group's agricultural data core.",
    image: "/images/agri.png",
    body: [
      "The Next-Gen Agriculture division has switched on data collection across its pilot plots, streaming soil, irrigation, and canopy telemetry from sensor arrays and drone imaging passes.",
      "Early datasets will train the division's crop-management models, targeting measurable yield gains under climate-smart practices.",
    ],
  },
  {
    id: "smart-district-site",
    tag: "Real Estate",
    date: "JUN 2026",
    readTime: "2 MIN READ",
    title: "Intelligent Real Estate Scouts First Smart District Site",
    excerpt:
      "Site evaluation is underway for a connected residential-commercial district engineered around the group's energy and software stack.",
    image: "/images/realestate.png",
    body: [
      "Intelligent Real Estate has opened site evaluation for its first smart district — a connected residential-commercial development designed around the group's microgrid and building-management software.",
      "The district concept embeds energy autonomy, sensor-driven maintenance, and high-yield tenancy design from day one.",
    ],
  },
];

export const INSIGHT_TAGS = ["All", "Company", "Technology", "Manufacturing", "Energy", "Agriculture", "Real Estate"];
